import Courier from "../component/Courier Department/Courier";
import DTDCcourier from "../component/DTDC Courier/dtdc_courier";
import ExcelUpload from "../component/Excel upload";
import InquiryList from "../component/InquiryList/inquiry";
import RecouierList from "../component/InquiryList/RecourierList";
import RefundList from "../component/InquiryList/RefundList";
import ResolvedQueryList from "../component/InquiryList/Resolved";
import ShreeNandanCourier from "../component/Shree Nandan Courier/shree_nandan_courier";
import ShreeTirupatiCourier from "../component/Shree Tirupati Courier/shree_tirupati_courier";
import UnicommerceData from "../component/unicommerce data/unicommerce";
import UnicommerceDataSearch from "../component/unicommerce data/unicommerce_search";
import AdminLayout from "../layout/admin-layout/adminLayout";
import AllTabs from "../component/InquiryList/Alltab";
import Undelivered from "../component/Undelivered/undelivered";
import Dashboard from "../component/Dashboard/dashboard";

const adminRoutesConfig = {
  path: "/admin",
  element: <AdminLayout />,
  children: [
    {
      path: "dashboard",
      element: <Dashboard />
    },
    {
      path: "dtdc_courier",
      element: <DTDCcourier />,
    },
    {
      path: "shree_nandan_courier",
      element: <ShreeNandanCourier />,
    },
    {
      path: "shree_tirupati_courier",
      element: <ShreeTirupatiCourier />,
    },
    {
      path: "excel-upload",
      element: <ExcelUpload />,
    },
    {
      path: "uniware",
      element: <UnicommerceData />,
    },
    {
      path: "unicommerce",
      element: <UnicommerceDataSearch />,
    },
    {
      path: "courier",
      element: <Courier />,
    },
    {
      path: "inquiry",
      element: <InquiryList />,
    },
    {
      path: "recourier",
      element: <RecouierList />,
    },
    {
      path: "refund",
      element: <RefundList />, // Assuming RecouierList is used for refunds as well
    },
    {
      path: "resolve",
      element: <ResolvedQueryList />, // Assuming RecouierList is used for refunds as well
    },
    {
      path: "all",
      element: <AllTabs />,
    },
    {
      path: "undelivered",
      element: <Undelivered />,
    },

  ],
};

export default adminRoutesConfig;
